import React from "react";
import {useTranslation} from "../../../../../general";
import {StockStatusHU} from "./StockStatusHU";
import {StockStatusEN} from "./StockStatusEN";
import {StockStatusRO} from "./StockStatusRO";

export const StockStatus = () => {
    const {locale} = useTranslation();

    switch (locale) {
        case 'hu':
            return <StockStatusHU/>;
        case 'en':
            return <StockStatusEN/>;
        case 'ro':
            return <StockStatusRO/>;
        default:
            return <StockStatusRO/>;
    }
}
